import { IdCanal, IdInbox } from "../common-types";
import { GenericServiceWithoutGetAll } from "../generic-service";

export type CreateCanal = {
  nome   : string,
  idInbox: IdInbox,
  rodizio?: boolean,
  /**
   * Política "Respeitar Jornada de Trabalho". Só tem efeito com `rodizio` ativo:
   * o sorteio passa a preferir quem está dentro da própria Jornada de Trabalho no
   * inbox e, sem ninguém disponível, cai para o rodízio padrão.
   */
  rodizioRespeitarJornadaTrabalho?: boolean,
  descricaoIa?: string
}

export type UpdateCanal = Partial<CreateCanal> & { id: IdCanal }

export type ResponseCanal = {
  id     : IdCanal;
  nome   : string,
  idInbox: IdInbox,
  rodizio: boolean,
  rodizioRespeitarJornadaTrabalho: boolean,
  descricaoIa: string,
  dataCriacao?: string,
  /** Posição escolhida por este usuário. `null` = nunca ordenado, vai para o fim. */
  ordem?: number | null
}

export class CanalService extends GenericServiceWithoutGetAll<CreateCanal, UpdateCanal, ResponseCanal> {
  constructor() { super('canais') }

  async getByIdInbox(idInbox: IdInbox) {
    return await this.f.get(``, {idInbox}) as ResponseCanal[]
  }

  async getAllByManyInbox(idInbox: IdInbox[]) {
    return await Promise.all(idInbox.map(async id => ({
      idInbox: id,
      canais: await this.getByIdInbox(id)
    })))
  }
}
